import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * 利用規約アイコン（ドキュメント＋テキスト行）
 * 元SVG: 求人詳細.svg
 * 元SVG offset (-31, -1263) を M 座標に適用済み
 * viewBox: 0 0 11 11
 */
const TermsIcon: React.FC<Props> = ({ color = 'currentColor', size = 24 }) => (
  <svg
    viewBox="0 0 11 11"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M1.77,0.19h6.86c.7,0,1.34.29,1.81.75.46.47.75,1.11.75,1.83v6.84c0,.72-.29,1.36-.75,1.83-.47.46-1.11.75-1.81.75h-6.86c-.7,0-1.36-.29-1.81-.75-.47-.47-.77-1.11-.77-1.83v-6.84c0-.72.29-1.36.77-1.83s1.11-.75,1.81-.75h0ZM1.16,9.89c-.2,0-.34-.15-.34-.33,0-.2.15-.34.34-.34h2.68c.2,0,.34.15.34.34,0,.18-.15.33-.34.33h-2.68ZM1.16,3.83c-.2,0-.34-.15-.34-.33,0-.2.15-.34.34-.34h7.4c.18,0,.33.15.33.34,0,.18-.15.33-.33.33h-7.4ZM1.16,5.86c-.2,0-.34-.15-.34-.34,0-.18.15-.33.34-.33h7.4c.18,0,.33.15.33.33,0,.2-.15.34-.33.34h-7.4ZM1.16,7.88c-.2,0-.34-.16-.34-.34s.15-.34.34-.34h2.68c.2,0,.34.16.34.34s-.15.34-.34.34h-2.68Z"
    />
  </svg>
);

export default TermsIcon;
